export enum AssessmentFilterFormTypes {
    Title = 'title',
    Vendor = 'vendor',
    Client = 'client',
    Status = 'status',
}